import React from "react";
import village from "../assets/images/villages.svg";

const VillageIllustration = () => {
  return (
    <div style={{ display: "flex", justifyContent: "center", alignItems: "center", overflow: "hidden" }}>
      <div
        style={{
          width: "100%",
          minWidth: 800,
          height: "auto",
          maxHeight: 480,
          aspectRatio: "800/480",
          WebkitMaskImage: `url(${village})`,
          maskImage: `url(${village})`,
          WebkitMaskSize: "contain",
          maskSize: "contain",
          WebkitMaskRepeat: "no-repeat",
          maskRepeat: "no-repeat",
          WebkitMaskPosition: "center",
          maskPosition: "center",
          backgroundColor: "var(--color-primary)",
          display: "block"
        }}
      />
    </div>
  );
};

export default VillageIllustration;
